import { render, staticRenderFns } from "./EmailList.vue?vue&type=template&id=2dfc30ba"
import script from "./EmailList.vue?vue&type=script&lang=js"
export * from "./EmailList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports